module.exports = __webpack_public_path__ + "img/back.7e75101d.svg";